// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZL3b","colMin":"styles_colMin__3b6lC"};